module.exports = __webpack_public_path__ + "static/media/mockups-1.3114b430.jpg";